export const DISCORD_LINK = 'https://discord.gg/cZsJT4NGPY'
